import {growthSvg as Icon__small__growthSvg} from '../Icon__small/Icon__small--growth.js'

export var growth = {
  name: 'growth',
  category: 'icon',
  colorable: true,
  svg: Icon__small__growthSvg,
};
